import { makeAutoObservable } from 'mobx';
import {
  defaultPercentage,
  TeamsSortBy,
} from 'pages/iPriseV2/common/enum/TeamUserRoles';

export class TeamLeadJobQueueService {
  newPage = 0;
  newRowsPerPage = 50;
  assignedPage = 0;
  assignedRowsPerPage = 50;
  readyForReviewPage = 0;
  readyForReviewRowsPerPage = 50;
  approvedPage = 0;
  approvedRowsPerPage = 50;
  subTab = 0;
  searchTerm = '';
  selectedTeam = '';
  selectedTeamName = '';
  selectedSort = String(TeamsSortBy.NEWEST_FIRST);
  percentage = defaultPercentage;

  constructor() {
    makeAutoObservable(this);
  }

  setNewPage(page: number) {
    this.newPage = page;
  }

  setNewRowsPerPage(rowsPerPage: number) {
    this.newRowsPerPage = rowsPerPage;
    this.newPage = 0;
  }

  setAssignedPage(page: number) {
    this.assignedPage = page;
  }

  setAssignedRowsPerPage(rowsPerPage: number) {
    this.assignedRowsPerPage = rowsPerPage;
    this.assignedPage = 0;
  }

  setReadyForReviewPage(page: number) {
    this.readyForReviewPage = page;
  }

  setReadyForReviewRowsPerPage(rowsPerPage: number) {
    this.readyForReviewRowsPerPage = rowsPerPage;
    this.readyForReviewPage = 0;
  }

  setApprovedPage(page: number) {
    this.approvedPage = page;
  }

  setApprovedRowsPerPage(rowsPerPage: number) {
    this.approvedRowsPerPage = rowsPerPage;
    this.approvedPage = 0;
  }

  setSubTab(tab: number) {
    this.subTab = tab;
  }

  setSearchTerm(term: string) {
    this.searchTerm = term;
    this.newPage = 0;
    this.assignedPage = 0;
    this.readyForReviewPage = 0;
    this.approvedPage = 0;
  }

  reset() {
    this.newPage = 0;
    this.newRowsPerPage = 50;
    this.assignedPage = 0;
    this.assignedRowsPerPage = 50;
    this.readyForReviewPage = 0;
    this.readyForReviewRowsPerPage = 50;
    this.approvedPage = 0;
    this.approvedRowsPerPage = 50;
    this.searchTerm = '';
    this.selectedTeam = '';
    this.selectedTeamName = '';
    this.selectedSort = String(TeamsSortBy.NEWEST_FIRST);
    this.percentage = defaultPercentage;
  }

  setSelectedTeam(team: string) {
    this.selectedTeam = team;
  }

  setSelectedTeamName(teamName: string) {
    this.selectedTeamName = teamName;
  }

  setSelectedSort(sort: string) {
    this.selectedSort = sort;
  }

  setPercentage(value: string) {
    this.percentage = value;
  }
}

export const teamLeadJobQueueService = new TeamLeadJobQueueService();
